import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'core/components/button';
import useStyles from './incidents-toolbar.styles';

// "Ignore (2)" when only part of the selection can be ignored, so a partial action is explicit
const withCount = (label, actionable, selected) =>
  actionable > 0 && actionable < selected ? `${label} (${actionable})` : label;

// Bulk actions for the selected incidents, on the table card's top edge (#36871). Ignore and Stop ignoring
// are reversible; Remove deletes the data, so it sits apart at the end. Each shows only with its permission.
const IncidentsToolbar = ({
  selectedCount,
  ignoreCount,
  stopIgnoringCount,
  showIgnore,
  showRemove,
  disabled,
  onIgnore,
  onStopIgnoring,
  onRemove,
  onClear
}) => {
  const classes = useStyles();
  return (
    <div className={classes.toolbar}>
      <span className={classes.selection} role="status">
        {selectedCount > 0 ? `${selectedCount} selected` : 'Select incidents to update'}
        {selectedCount > 0 && (
          <Button variant="text" color="secondary" onClick={onClear}>
            Clear selection
          </Button>
        )}
      </span>
      {showIgnore && (
        <>
          <Button
            variant="outlined"
            color="primary"
            className={classes.action}
            disabled={disabled || !ignoreCount}
            onClick={onIgnore}
          >
            {withCount('Ignore', ignoreCount, selectedCount)}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            className={classes.action}
            disabled={disabled || !stopIgnoringCount}
            onClick={onStopIgnoring}
          >
            {withCount('Stop ignoring', stopIgnoringCount, selectedCount)}
          </Button>
        </>
      )}
      {showRemove && (
        <Button
          variant="text"
          className={`${classes.action} ${classes.remove}`}
          disabled={disabled || !selectedCount}
          onClick={onRemove}
        >
          Remove by date
        </Button>
      )}
    </div>
  );
};

IncidentsToolbar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  ignoreCount: PropTypes.number.isRequired,
  stopIgnoringCount: PropTypes.number.isRequired,
  showIgnore: PropTypes.bool.isRequired,
  showRemove: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onIgnore: PropTypes.func.isRequired,
  onStopIgnoring: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

IncidentsToolbar.defaultProps = {
  disabled: false
};

export default IncidentsToolbar;
